const listPointsBody = document.querySelector('#posters').querySelector('div[name=body]');
import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';

export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index) {
    let urlImg = '';
    if(item.image)
      urlImg = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/posters/${item.image}_preview_300.jpg`;
    else
      urlImg = '';


  return `<div class = "card_poster_preview column p-1 " pID=${item.id}> 
              <img  pID=${item.id} style = "width:auto; height:auto;" src="${urlImg}" class="shimmer">
              <label pID=${item.id}>${item.creator}</label>
          </div>`;
  },

  drawDataInContainer(enterprisesData) {
    this.cleanContainer();
    // listPointsBody.innerHTML = '<div class="row p-1">';
    if(enterprisesData)
      enterprisesData.forEach((item, index) => listPointsBody.insertAdjacentHTML('beforeend', this.getElement(item, index)));
    // listPointsBody.insertAdjacentHTML('beforeend', '</div>');
  },

  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
